<template>
	<div>
		<span class="flex justify-evenly" @click="onClick()">
			<span style="padding-left: 4px">{{ displayValue }}</span>
			<span :title="$t('Edit')" style="height: 30px">🖉</span>
		</span>
	</div>
</template>

<script>
export default {
	data() {
		return {
			displayValue: "",
		};
	},
	beforeMount() {
		this.displayValue = this.params.hasOwnProperty("value") ? this.params.value : this.params.setValue(0);
	},
	methods: {
		onClick() {
			this.params.api.startEditingCell({
				rowIndex: this.params.rowIndex,
				colKey: this.params.column.getId(),
			});
		},
	},
};
</script>
